// Países que el visitante puede elegir manualmente (selector de país,
// combo del login, etc.). Independiente de footerDatosPorPais.js a
// propósito: esta lista es sobre qué países soporta la app en general,
// no sobre qué contenido de footer existe para cada uno — así, agregar un
// país nuevo a este selector no depende de qué tan completos estén sus
// datos de footer.
const PAISES_SOPORTADOS = [
  { codigo: "GT", nombre: "Guatemala" },
  { codigo: "CR", nombre: "Costa Rica" },
];

export default PAISES_SOPORTADOS;
